import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import SEOHelmet from "../SEOHelmet";
import Navbar from "../Navbar";
import ContactMe from "../ContactMe";
import Footer from "../Footer";
import FeaturedPosts from "../../blog/components/FeaturedPosts";
import Config from "../../Config";
import { useLanguage } from "../../i18n";

// Social Media SVG Icons
const LinkedInIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const GitHubIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  </svg>
);

const XIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

function Home() {
    const [gravatarUrl, setGravatarUrl] = useState(null);
    const [avatarLoading, setAvatarLoading] = useState(true);
    const { t } = useLanguage();

    useEffect(() => {
        const email = Config.email;
        const trimmedEmail = email.trim().toLowerCase();
        const md5Hash = CryptoJS.MD5(trimmedEmail).toString();
        const url = `https://www.gravatar.com/avatar/${md5Hash}?s=320`;
        let objectUrl = null;

        fetch(url)
            .then(res => res.blob())
            .then(blob => {
                objectUrl = URL.createObjectURL(blob);
                setGravatarUrl(objectUrl);
                setAvatarLoading(false);
            })
            .catch(() => {
                setGravatarUrl(url);
                setAvatarLoading(false);
            });

        return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, []);

    const socialLinks = [
        { name: 'LinkedIn', url: Config.socialMediaUrl?.linkedin, icon: LinkedInIcon },
        { name: 'GitHub', url: Config.socialMediaUrl?.github, icon: GitHubIcon },
        { name: 'X', url: Config.socialMediaUrl?.x, icon: XIcon },
        { name: 'Instagram', url: Config.socialMediaUrl?.instagram, icon: InstagramIcon },
    ].filter(link => link.url);

    return (
        <>
      <SEOHelmet />
      <div className="min-h-screen bg-white">
        <Navbar />
            
            {/* Hero Section */}
            <section className="relative pt-32 pb-20 lg:pt-36 lg:pb-24">
                <div className="max-w-6xl mx-auto px-5">
                    <div className="grid lg:grid-cols-2 gap-12 items-center">
                        {/* Left: Intro */}
                        <div className="order-2 lg:order-1">
                            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-medium mb-6">
                                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                                {t('home.available')}
                            </div>
                            
                            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
                                {t('home.headline1')} <span className="text-blue-600">{Config.name}</span>
                            </h1>
                            
                            <p className="text-lg text-gray-600 leading-relaxed mb-8">
                                {t('home.heroPart1')}<span className="font-semibold text-gray-900">{t('home.descriptionBold')}</span>{t('home.heroPart2')}
                            </p>
                            
                            {/* CTA Buttons */}
                            <div className="flex flex-wrap gap-4 mb-8">
                                <Link 
                                    to="/blog"
                                    className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition-all hover:scale-105"
                                >
                                    {t('home.ctaBlog')}
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                    </svg>
                                </Link>
                                <Link 
                                    to="/resume"
                                    className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-200 text-gray-700 rounded-lg font-medium hover:border-gray-300 hover:bg-gray-50 transition-all"
                                >
                                    {t('home.ctaResume')}
                                </Link>
                            </div>

                            {/* Social Links */}
                            <div className="flex items-center gap-4">
                                <span className="text-sm text-gray-500">{t('home.findMeOn')}</span>
                                <div className="flex gap-3">
                                    {socialLinks.map((link) => {
                                        const Icon = link.icon;
                                        return (
                                            <a
                                                key={link.name}
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-900 hover:text-white flex items-center justify-center text-gray-600 transition-all duration-200"
                                                title={link.name}
                                            >
                                                <Icon />
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        {/* Right: Avatar/Photo */}
                        <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
                            <div className="relative">
                                {/* Background decoration */}
                                <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full blur-3xl opacity-60 scale-110"></div>
                                
                                {/* Profile Photo */}
                                <div className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full overflow-hidden shadow-2xl border-4 border-white">
                                    {avatarLoading ? (
                                        <div style={{
                                            width: '100%',
                                            height: '100%',
                                            animation: 'skeleton-loading 1.5s ease-in-out infinite'
                                        }} />
                                    ) : (
                                        <img
                                            src={gravatarUrl}
                                            alt={Config.name}
                                            className="w-full h-full object-cover"
                                        />
                                    )}
                                </div>
                                
                                {/* Floating badges */}
                                <div className="absolute -bottom-2 -left-4 bg-white rounded-xl shadow-lg px-4 py-2 flex items-center gap-2 animate-bounce">
                                    <span className="text-2xl">⚡</span>
                                    <span className="text-sm font-medium text-gray-700">{t('home.badge1')}</span>
                                </div>
                                <div className="absolute -top-2 -right-4 bg-white rounded-xl shadow-lg px-4 py-2 flex items-center gap-2 animate-bounce" style={{ animationDelay: '0.5s' }}>
                                    <span className="text-2xl">🚀</span>
                                    <span className="text-sm font-medium text-gray-700">{t('home.badge2')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Featured Blog Posts */}
            <section id="blog" className="py-16 bg-gray-50">
                <div className="max-w-6xl mx-auto px-5">
                    <FeaturedPosts />
                </div>
            </section>

            {/* What I Do */}
            <section className="py-16">
                <div className="max-w-6xl mx-auto px-5">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('home.whatIDo.title')}</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            {t('home.whatIDo.subtitle')}
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {t('home.whatIDo.cards').map((item, index) => (
                            <div key={index} className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-lg transition-shadow">
                                <div className="text-4xl mb-4">{item.icon}</div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                                <p className="text-gray-600">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="py-16 bg-gray-50">
                <div className="max-w-6xl mx-auto px-5">
                    <ContactMe />
                </div>
            </section>

            <Footer />
        </div>
    </>
  );
}

export default Home;
